var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactNativeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "446px",
    viewBox: "0 0 800 446",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "react-logo@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6D5E",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9139",
    offset: "47.7737107%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9816F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.8%",
    y: "-22.6%",
    width: "143.6%",
    height: "145.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9816F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B32257",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2A08E",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.8%",
    y: "-21.8%",
    width: "143.6%",
    height: "143.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61529C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#861C77",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.8%",
    y: "-21.8%",
    width: "143.6%",
    height: "143.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89C7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#568697",
    offset: "99.9890734%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.8%",
    y: "-21.8%",
    width: "143.6%",
    height: "143.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19181D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-10",
    x: 250,
    y: 64,
    width: 300,
    height: 300
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.5%",
    y: "-5.5%",
    width: "111.7%",
    height: "111.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AEFFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DAFB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AEFFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DAFB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "react-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#1F2026",
    x: 0,
    y: 0,
    width: 800,
    height: 446
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    filter: "url(#filter-2)",
    x: 235,
    y: 55,
    width: 165,
    height: 159
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-3)",
    filter: "url(#filter-4)",
    x: 235,
    y: 207,
    width: 165,
    height: 165
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-5)",
    filter: "url(#filter-6)",
    x: 400,
    y: 207,
    width: 165,
    height: 165
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "url(#linearGradient-7)",
    filter: "url(#filter-8)",
    x: 400,
    y: 55,
    width: 165,
    height: 165
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    strokeOpacity: 0.397536058,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    fill: "url(#linearGradient-9)",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "React-icon-(1)",
    transform: "translate(276.000000, 103.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248,110.525292 C248,94.0856031 227.426009,78.5058366 195.882593,68.844358 C203.161843,36.6731518 199.92662,11.077821 185.671423,2.88326848 C182.38565,0.961089494 178.543824,0.0505836576 174.348145,0.0505836576 L174.348145,11.3307393 C176.673461,11.3307393 178.543824,11.7859922 180.110885,12.6459144 C186.985732,16.5914397 189.968202,31.614786 187.642886,50.9377432 C187.086832,55.692607 186.176926,60.7003891 185.064819,65.8093385 C175.156951,63.381323 164.339177,61.5097276 152.965349,60.2957198 C146.141052,50.9377432 139.064003,42.4396887 131.936404,35.0038911 C148.415817,19.6770428 163.884223,11.2801556 174.398695,11.2801556 L174.398695,0 C174.398695,0 174.398695,0 174.398695,0 C160.49735,0 142.299225,9.91439689 123.898899,27.1128405 C105.498573,10.0155642 87.3004484,0.20233463 73.3991031,0.20233463 L73.3991031,11.4824903 C83.8630249,11.4824903 99.3819812,19.8287938 115.861394,35.0544747 C108.784346,42.4902724 101.707297,50.9377432 94.9841011,60.2957198 C83.5597228,61.5097276 72.7419486,63.381323 62.8340807,65.8599222 C61.6714227,60.8015564 60.8120669,55.8949416 60.2054627,51.1906615 C57.8295964,31.8677043 60.7615165,16.844358 67.5858133,12.848249 C69.1023237,11.9377432 71.0737872,11.5330739 73.3991031,11.5330739 L73.3991031,0.252918288 C73.3991031,0.252918288 73.3991031,0.252918288 73.3991031,0.252918288 C69.152874,0.252918288 65.3110477,1.16342412 61.9747248,3.08560311 C47.7700775,11.2801556 44.5854056,36.8249027 51.9152059,68.8949416 C20.4728903,78.6070039 0,94.1361868 0,110.525292 C0,126.964981 20.573991,142.544747 52.1174073,152.206226 C44.8381574,184.377432 48.0733795,209.972763 62.3285773,218.167315 C65.6143498,220.089494 69.4561761,221 73.7024052,221 C87.6037505,221 105.801875,211.085603 124.202201,193.88716 C142.602528,210.984436 160.800652,220.797665 174.701998,220.797665 C178.948227,220.797665 182.790053,219.88716 186.126376,217.964981 C200.331023,209.770428 203.515695,184.225681 196.185895,152.155642 C227.52711,142.494163 248,126.914397 248,110.525292 Z M182.183449,76.7859922 C180.313086,83.311284 177.98777,90.0389105 175.359152,96.766537 C173.286588,92.7198444 171.112923,88.6731518 168.737057,84.6264591 C166.411741,80.5797665 163.934774,76.6342412 161.457807,72.7898833 C168.635956,73.8521401 175.561353,75.1673152 182.183449,76.7859922 Z M159.03139,130.657588 C155.088463,137.486381 151.044435,143.961089 146.848757,149.980545 C139.316755,150.638132 131.683653,150.992218 124,150.992218 C116.366898,150.992218 108.733795,150.638132 101.252344,150.031128 C97.0566653,144.011673 92.9620872,137.587549 89.0191602,130.809339 C85.1773339,124.182879 81.68936,117.455253 78.5046881,110.677043 C81.6388096,103.898833 85.1773339,97.1206226 88.9686099,90.4941634 C92.9115369,83.6653696 96.9555646,77.1906615 101.151243,71.1712062 C108.683245,70.5136187 116.316347,70.1595331 124,70.1595331 C131.633102,70.1595331 139.266205,70.5136187 146.747656,71.1206226 C150.943335,77.1400778 155.037913,83.5642023 158.98084,90.3424125 C162.822666,96.9688716 166.31064,103.696498 169.495312,110.474708 C166.31064,117.252918 162.822666,124.031128 159.03139,130.657588 Z M175.359152,124.081712 C178.088871,130.859922 180.414187,137.638132 182.3351,144.214008 C175.713004,145.832685 168.737057,147.198444 161.508357,148.2607 C163.985324,144.365759 166.462291,140.36965 168.787607,136.272374 C171.112923,132.225681 173.286588,128.128405 175.359152,124.081712 Z M124.101101,178.054475 C119.399918,173.198444 114.698736,167.785992 110.048104,161.867704 C114.597636,162.070039 119.248267,162.22179 123.94945,162.22179 C128.701182,162.22179 133.402364,162.120623 138.002446,161.867704 C133.452915,167.785992 128.751733,173.198444 124.101101,178.054475 Z M86.4916429,148.2607 C79.3134937,147.198444 72.3880962,145.883268 65.7660008,144.264591 C67.6363636,137.7393 69.9616796,131.011673 72.5902976,124.284047 C74.6628618,128.330739 76.8365267,132.377432 79.212393,136.424125 C81.5882593,140.470817 84.0146759,144.416342 86.4916429,148.2607 Z M123.848349,42.9961089 C128.549531,47.8521401 133.250713,53.2645914 137.901345,59.1828794 C133.351814,58.9805447 128.701182,58.8287938 124,58.8287938 C119.248267,58.8287938 114.547085,58.9299611 109.947004,59.1828794 C114.496535,53.2645914 119.197717,47.8521401 123.848349,42.9961089 Z M86.4410925,72.7898833 C83.9641256,76.6848249 81.4871586,80.6809339 79.1618426,84.7782101 C76.8365267,88.8249027 74.6628618,92.8715953 72.5902976,96.9182879 C69.8605789,90.1400778 67.5352629,83.3618677 65.6143498,76.7859922 C72.2364452,75.2178988 79.212393,73.8521401 86.4410925,72.7898833 Z M40.6930289,136.120623 C22.7982063,128.48249 11.2221769,118.466926 11.2221769,110.525292 C11.2221769,102.583658 22.7982063,92.5175097 40.6930289,84.9299611 C45.0403587,83.0583658 49.7920913,81.3891051 54.6954749,79.8210117 C57.5768447,89.7354086 61.3681207,100.054475 66.0693029,110.626459 C61.418671,121.14786 57.6779454,131.416342 54.847126,141.280156 C49.8426417,139.712062 45.0909091,137.992218 40.6930289,136.120623 Z M67.8891154,208.404669 C61.0142682,204.459144 58.0317978,189.435798 60.3571137,170.11284 C60.9131675,165.357977 61.8230738,160.350195 62.9351814,155.241245 C72.8430493,157.669261 83.6608235,159.540856 95.0346514,160.754864 C101.858948,170.11284 108.935997,178.610895 116.063596,186.046693 C99.5841826,201.373541 84.1157766,209.770428 73.6013045,209.770428 C71.3265389,209.719844 69.4056258,209.264591 67.8891154,208.404669 Z M187.794537,169.859922 C190.170404,189.182879 187.238483,204.206226 180.414187,208.202335 C178.897676,209.11284 176.926213,209.51751 174.600897,209.51751 C164.136975,209.51751 148.618019,201.171206 132.138606,185.945525 C139.215654,178.509728 146.292703,170.062257 153.015899,160.70428 C164.440277,159.490272 175.258051,157.618677 185.165919,155.140078 C186.328577,160.249027 187.238483,165.155642 187.794537,169.859922 Z M207.256421,136.120623 C202.909091,137.992218 198.157358,139.661479 193.253975,141.229572 C190.372605,131.315175 186.581329,120.996109 181.880147,110.424125 C186.530779,99.9027237 190.271504,89.6342412 193.102324,79.770428 C198.106808,81.3385214 202.858541,83.0583658 207.306971,84.9299611 C225.201794,92.5680934 236.777823,102.583658 236.777823,110.525292 C236.727273,118.466926 225.151243,128.533074 207.256421,136.120623 Z",
    id: "Shape",
    fill: "url(#linearGradient-12)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-13)",
    cx: 123,
    cy: 111,
    r: 23
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactNativeLogo);
export default __webpack_public_path__ + "static/media/react-native-logo.655915c095536d533e1cf10b617ab75e.svg";
export { ForwardRef as ReactComponent };